




















import Vue from 'vue'
import Component from 'vue-class-component';
import {State} from 'vuex-class';
import AppRelease from '@/modules/app-router/model/AppRelease';
import {Prop} from 'vue-property-decorator';
import {notify} from '@/modules/core/notification';

/**
 * Dialogo de confirmación para eliminar una distribución
 *
 * @author Alejandro G. Riaño <agutierrez@softcontrol.es>
 */
@Component
export default class ConfirmDeleteRelease extends Vue {
    /**
     * Controla la visibilidad del componente
     *
     * @var { boolean }
     */
    @Prop({type: Boolean, default: false})
    public value: boolean

    /**
     * Distribución actualmente seleccionada por el usuario
     */
    @State(state => state.appRouter.release)
    public release: AppRelease

    public deleting = false

    /**
     * Solicita a la aplicación la eliminación de la distribución actualmente
     * seleccionada por el usuario
     */
    public async remove () {
        this.deleting = true
        await this.$store.dispatch('appRouter/deleteAppRelease')

        this.deleting = false
        this.$emit('input', false)
        notify('La distribución ha sido eliminada correctamente')
    }

    public errorCaptured () {
        this.deleting = false
    }
}
